module.exports = __webpack_public_path__ + "4e82463d0f9293120da93e234ebd6d0a.svg";